"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketLifecycleConfigurationInput_1 = require("./PutBucketLifecycleConfigurationInput");
var PutBucketLifecycleConfigurationOutput_1 = require("./PutBucketLifecycleConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketLifecycleConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketLifecycleConfiguration",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?lifecycle"
    },
    input: {
        shape: PutBucketLifecycleConfigurationInput_1.PutBucketLifecycleConfigurationInput
    },
    output: {
        shape: PutBucketLifecycleConfigurationOutput_1.PutBucketLifecycleConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketLifecycleConfiguration.js.map